module.exports = __webpack_public_path__ + "files/SPIADI2026 - EXP ADI - Tableau Exp-Dia.f176dfc93e1fff6af46c7ff639537587.pdf";